// extracted by mini-css-extract-plugin
export default {"container":"jo-z","bubbleNav":"ko-z","graphic":"lo-z","contact":"mo-z"};